import Flex from '../../generic/Flex';
import Icon, { type IconClassName } from '../../generic/Icon';
import { RouterLink } from '../../generic/Link';

import styles from './SummaryActionLink.module.less';

type SummaryActionLinkProps = {
  to: string;
  action: string;
  icon: IconClassName;
};

/**
 * Component for rendering an action option found on the new summary page.
 * This component does not handle actions other than router navigation.
 *
 * @param {object} params The parameters for the component
 * @param {string} params.to Where the user should be redirected to upon clicking the action button.
 * @param {string} params.action The button label.
 * @param {IconClassName} params.icon The icon to display.
 */
const SummaryActionLink = ({
  to,
  action,
  icon,
}: SummaryActionLinkProps) =>
  <RouterLink to={to}>
    <Flex className={styles.container} gap={12}>
      <span>{action}</span>
      <Icon icon={icon} />
    </Flex>
  </RouterLink>;

export default SummaryActionLink;
